export const blockIconsDevicePin = (
	<span className='material-symbols-outlined'>pin</span>
);
